import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { useRoomBackgroundImage } from '../../hooks/useRoomBackgroundImage';

import { ScreenRoomPreviewStyles } from './RoomPreview.styles';

export const ScreenRoomPreview: React.FC = () => {
  const { wizard } = useOnboarding();
  const backgroundImage = useRoomBackgroundImage();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'RoomPreview',
      });
    }
  }, []);

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <ScreenRoomPreviewStyles
      background={'dark-solid'}
      bgImage={<img src={backgroundImage} alt="Chat Vibe" />}
    >
      <IonContent>
        <UiTypography
          variant="title-medium"
          align="center"
          className="local-title"
          fontStyle="italic"
        >
          A mysterious stranger is already inside. Do you dare to meet her?
        </UiTypography>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        buttonText={'Yes, open the door'}
      />
    </ScreenRoomPreviewStyles>
  );
};
